import React from 'react';
import PropTypes from 'prop-types';
import {cdnResize} from '../services/utils';
import {FormattedMessage} from 'react-intl';
import {historyPush, getLinkQueryString} from '../services/history';
import classNames from 'classnames';
import {openAppInModal} from '../services/app-flow';
import {execBI} from '../services/bi-events-manager';
import {isExperiment} from '../config';
import ALink from './ALink';
import injectMain from '../services/inject-main';

const handleCategoryBI = (slug, getInputValue) => {
  return () => {
    execBI('CATEGORY_LINK_CLICK', {category: slug, origin: 'search_auto'});
    execBI('AUTO_COMPLETE_SUBMIT', {category: slug, type: 'category', auto_search_term: getInputValue()});
  };
};

const handleDoSearch = (q, getInputValue) => {
  return ev => {
    ev.preventDefault();
    execBI('AUTO_COMPLETE_SUBMIT', {type: 'search_term', auto_search_term: getInputValue(), search_term: q});
    execBI('SEARCH_INPUT_SUBMIT', {search_term: q, origin: 'search_auto'});
    historyPush(`/search/${getLinkQueryString({q})}`);
  };
};


class SearchSuggestion extends React.Component {

  handleOpenApp(app, getInputValue, biPosition) {
    return ev => {
      if (!isExperiment('specs.market.AppPageInsideMarket', this.props.experiments) && this.props.market === 'editor') {
        ev.preventDefault();
        openAppInModal(app.slug);
      }

      execBI('AUTO_COMPLETE_SUBMIT', {type: 'app', auto_search_term: getInputValue(), app_id: app.appDefinitionId});
      execBI('APP_MODAL_OPEN_CLICK', {app, biPosition});
    };
  }

  renderEmpty() {
    const defaultPopular = this.props.defaultPopular;
    const activeIndex = this.props.activeIndex;

    return (
      <div className="empty-query">
        <div className="title"><FormattedMessage id="editor.search.popular"/></div>
        <ul className="popular-searches typography_t2">
          {defaultPopular.map((s, i) =>
            <li key={s} className={classNames({active: activeIndex === i})}>
              <a href="#" onClick={handleDoSearch(s, this.props.getInputValue)}>{s}</a>
            </li>
          )}
        </ul>
      </div>
    );
  }

  renderResults() {
    const results = this.props.results;
    const activeIndex = this.props.activeIndex;

    return (
      <div className="results">

        {results.popular.length ?
          <ul className="popular-searches typography_t2">
            {results.popular.map((s, i) =>
              <li key={s} className={classNames({active: activeIndex === i})}>
                <a href="#" onClick={handleDoSearch(s, this.props.getInputValue)}>{s}</a>
              </li>
            )}
          </ul> : ''}

        {results.apps.length ? <div className="title"><FormattedMessage id="application.word.apps"/></div> : ''}
        {results.apps.length ?
          <ul className="applications typography_t2">
            {results.apps.map((app, i) =>
              <li key={app.slug} className={classNames({active: activeIndex === i + results.popular.length})}>
                <ALink className="application-title" to={`/${app.slug}/overview`} onClick={this.handleOpenApp(app, this.props.getInputValue, i + 1)}>
                  <img
                    width="32"
                    height="32"
                    src={cdnResize(app.roundIcon || app.appIcon, 32, 32)}
                    alt={`${app.name} by ${app.by} || WIX App Market`}
                    />
                  <span>{app.name} </span>
                  <span className="made-by"><FormattedMessage id="application.byAppMarket20" values={{company: app.by}}/></span>
                </ALink>
              </li>)}
          </ul> : ''}

        {results.categories.length ? <div className="title"><FormattedMessage id="navigation.button.categories"/></div> : ''}
        {results.categories.length ?
          <ul className="categories typography_t2">
            {results.categories.map((category, i) =>
              <li key={category.path} className={classNames({active: activeIndex === i + results.popular.length + results.apps.length})}>
                <ALink to={`/${category.path}`} onClick={handleCategoryBI(category.slug, this.props.getInputValue)}>{category.name}</ALink>
              </li>
            )}
          </ul> : ''}

      </div>
    );
  }

  render() {
    if (this.props.show) {
      return (
        <div className="search-suggestion">
          {this.props.empty ? this.renderEmpty() : ''}
          {!this.props.empty ? this.renderResults() : ''}
        </div>
      );
    }
    return null;
  }
}

SearchSuggestion.propTypes = {
  show: PropTypes.bool,
  results: PropTypes.object.isRequired,
  defaultPopular: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  empty: PropTypes.bool,
  getInputValue: PropTypes.func,
  market: PropTypes.string,
  experiments: PropTypes.object
};

export default injectMain(SearchSuggestion);



// WEBPACK FOOTER //
// ./components/Search-suggestion.js